import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { idx } from '@uzurv/core';

@Component({
  selector: 'app-generic-autocomplete-results',
  templateUrl: './generic-autocomplete-results.component.html',
  styleUrls: ['./generic-autocomplete-results.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GenericAutocompleteResultsComponent {
  @Input() autocompleteResults: Array<any>;
  // This property is necessary for test automation to have unique ID's on the rows
  @Input() testingIdAccessor: string;
  @Input() columnNames: Array<string>;
  /**
   * displayedFields is a list of groups of paths to fields in the provided autocomplete object
   *
   * For example, if the provided list objects are shaped like:
  ```
  {
    partnerIdentifier: 'UZ1234',
    rider: {
      firstName: 'Bill',
      lastName: 'Rider'
    }
  }
  ```
   * a list of paths like
   *
   * `[[['rider', 'firstName'], ['rider', 'lastName']], [['partnerIdentifier']]]`
   *
   * would fill the autocomplete result with `Bill Rider             UZ1234`
   *
   * Accessors can either be object field names as strings, or indexes of array members
   */
  @Input() displayedFields: Array<Array<any>>;
  @Output() resultSelected = new EventEmitter<any>();

  idx = idx;

  selectAutocompleteResult(result: any): void {
    this.resultSelected.emit(result);
  }
}
